<template>
    <DashboardLayout>
        <div class="home">
            <section class="summary">
                <div class="d-flex flex-column rounded align-items-start content-1">
                    <router-link
                        :to="isGroupMember ? { name: 'ViewMemos', query: { status: 'pending' } } : { name: 'ViewAppraisals', query: pendingAppraisalQuery }"
                        class="text-decoration-none single-action-card w-100 h-100 d-flex flex-column justify-content-center align-items-start">
                        <h4 class="fw-semibold">{{ isGroupMember ? 'Pending Memos:' : 'Pending Appraisal Requests:' }}
                        </h4>
                        <div v-if="isGroupMember ? loadingMemos : loadingAppraisals"
                            class="skeleton-bar skeleton-count mb-2"></div>
                        <p v-else class="fw-normal mb-2">{{ isGroupMember ? numberOfPendingMemos :
                            numberOfPendingAppraisals }} {{ isGroupMember ? 'awaiting initiation' : 'awaiting approval'
                            }}</p>
                    </router-link>
                </div>
                <!-- <div class="d-flex flex-column align-items-start content-2">
                    <router-link :to="{ name: 'ViewWarrants', query: { date: 'this_month' } }"
                        class="text-decoration-none single-action-card w-100 h-100 d-flex flex-column justify-content-center align-items-start">
                        <h4 class="fw-semibold">Warrants Issued:</h4>
                        <div v-if="loadingCounts" class="skeleton-bar skeleton-count mb-2"></div>
                        <p v-else class="fw-normal mb-2">{{ numberOfWarrantsThisMonth }} this month</p>
                    </router-link>
                </div> -->
            </section>

            <!-- Quick Actions -->
            <section class="summary-actions d-flex flex-column" :key="menuVersion">
                <h2 class="mb-4">Quick Actions</h2>
                <div class="action-container-row d-flex flex-wrap w-100">
                    <div class="single-action-wrapper" v-if="hasAccess(['registryOfficer', 'qssu', ''])">
                        <router-link :to="{ name: 'CreateMemo' }">
                            <div class="single-action-card">
                                <div class="action-icon">
                                    <span class="material-symbols-outlined">add_notes</span>
                                </div>
                                <h3 class="fw-semibold">Create Memo</h3>
                            </div>
                        </router-link>
                    </div>
                    <div class="single-action-wrapper" v-if="hasAccess(['qssu', ''])">
                        <router-link :to="{ name: 'UploadBudget' }">
                            <div class="single-action-card">
                                <div class="action-icon">
                                    <span class="material-symbols-outlined">drive_folder_upload</span>
                                </div>
                                <h3 class="fw-semibold">Upload Budget</h3>
                            </div>
                        </router-link>
                    </div>
                    <div class="single-action-wrapper" v-if="hasAccess([''])">
                        <router-link :to="{ name: 'CreateApprovalAuthority' }">
                            <div class="single-action-card">
                                <div class="action-icon">
                                    <span class="material-symbols-outlined">person</span>
                                </div>
                                <h3 class="fw-semibold">Create Approval Authority</h3>
                            </div>
                        </router-link>
                    </div>
                    <div class="single-action-wrapper"
                        v-if="hasAccess(['qssu', 'dirOfBudget', 'perSec', 'commOfBAndP', 'registryOfficer', 'groupHead', ''])">
                        <router-link :to="{ name: 'ViewSectors' }">
                            <div class="single-action-card">
                                <div class="action-icon">
                                    <span class="material-symbols-outlined ">summarize</span>
                                </div>
                                <h3 class="fw-semibold">View all Sectors</h3>
                            </div>
                        </router-link>
                    </div>
                    <div class="single-action-wrapper" v-if="hasAccess(['groupHead', 'groupMember', ''])">
                        <router-link :to="{ name: 'ViewWarrants' }">
                            <div class="single-action-card">
                                <div class="action-icon">
                                    <span class="material-symbols-outlined">article</span>
                                </div>
                                <h3 class="fw-semibold">Download a Warrant</h3>
                            </div>
                        </router-link>
                    </div>
                    <div class="single-action-wrapper"
                        v-if="hasAccess(['qssu', 'dirOfBudget', 'perSec', 'commOfBAndP', ''])">
                        <router-link :to="{ name: 'ViewBudgets' }">
                            <div class="single-action-card">
                                <div class="action-icon">
                                    <span class="material-symbols-outlined">credit_score</span>
                                </div>
                                <h3 class="fw-semibold">View all Budgets</h3>
                            </div>
                        </router-link>
                    </div>
                    <div class="single-action-wrapper" v-if="hasAccess([''])">
                        <router-link :to="{ name: 'ViewApprovalAuthorities' }">
                            <div class="single-action-card">
                                <div class="action-icon">
                                    <span class="material-symbols-outlined">person_edit</span>
                                </div>
                                <h3 class="fw-semibold">Edit Approval Authority</h3>
                            </div>
                        </router-link>
                    </div>
                    <div class="single-action-wrapper" v-if="hasAccess(['groupMember'])">
                        <router-link :to="{ name: 'ViewMemos' }">
                            <div class="single-action-card">
                                <div class="action-icon">
                                    <span class="material-symbols-outlined">description</span>
                                </div>
                                <h3 class="fw-semibold">View Memos</h3>
                            </div>
                        </router-link>
                    </div>
                    <div class="single-action-wrapper" v-if="hasAccess(['groupMember'])">
                        <router-link :to="{ name: 'ViewAppraisals' }">
                            <div class="single-action-card">
                                <div class="action-icon">
                                    <span class="material-symbols-outlined">fact_check</span>
                                </div>
                                <h3 class="fw-semibold">View Appraisals</h3>
                            </div>
                        </router-link>
                    </div>
                    <div class="single-action-wrapper">
                        <router-link :to="{ name: 'ViewMdas' }">
                            <div class="single-action-card">
                                <div class="action-icon">
                                    <span class="material-symbols-outlined ">summarize</span>
                                </div>
                                <h3 class="fw-semibold">View all Mdas</h3>
                            </div>
                        </router-link>
                    </div>
                </div>
            </section>

            <!-- Recent Appraisals (Recent Memos for group members) -->
            <section class="summary-table d-flex flex-column">
                <h2 class="mb-4">{{ isGroupMember ? 'Recent Memos' : 'Recent Appraisal Requests' }}</h2>

                <div class="table-wrapper">
                    <div v-if="isGroupMember" class="table-container border rounded rounded-table">
                        <table class="responsive-table">
                            <thead>
                                <tr>
                                    <th scope="col"></th>
                                    <th scope="col">File Title</th>
                                    <th scope="col">File Number / Approval Authority</th>
                                    <th scope="col">Creation Date</th>
                                    <th scope="col">Originating MDA</th>
                                    <th scope="col" class="text-end">Amount Approved</th>
                                    <th scope="col">Status</th>
                                </tr>
                            </thead>
                            <tbody>
                                <template v-if="loadingMemos">
                                    <tr v-for="n in 5" :key="'memo-skeleton-' + n" class="skeleton-row">
                                        <td>
                                            <div class="skeleton-bar skeleton-sm mx-auto"></div>
                                        </td>
                                        <td>
                                            <div class="skeleton-bar"></div>
                                        </td>
                                        <td>
                                            <div class="skeleton-bar"></div>
                                        </td>
                                        <td>
                                            <div class="skeleton-bar"></div>
                                        </td>
                                        <td>
                                            <div class="skeleton-bar"></div>
                                        </td>
                                        <td>
                                            <div class="skeleton-bar"></div>
                                        </td>
                                        <td>
                                            <div class="skeleton-bar skeleton-sm"></div>
                                        </td>
                                    </tr>
                                </template>

                                <template v-else>
                                    <tr v-for="(item, index) in sortedMemos" :key="item.type + '-' + item.id"
                                        :class="index % 2 === 0 ? 'row-even' : 'row-odd'">
                                        <td scope="row" class="serial-no text-center">{{ index + 1 }}</td>
                                        <td class="primary-col text-start">
                                            <router-link
                                                :to="{ name: 'ViewMemo', params: { id: item.id }, query: { mdaid: item.mdaId, year: item.year } }"
                                                class="view-link text-decoration-underline">
                                                {{ item.fileTitle }}
                                            </router-link>
                                        </td>
                                        <td class="secondary-col text-start">{{ item.fileNumber }}</td>
                                        <td class="secondary-col memo-date">{{ formatDate(item.date) }}</td>
                                        <td class="secondary-col text-start">{{ item.originatingMda }}</td>
                                        <td class="secondary-col text-end">{{ formatCurrency(item.amountApproved || 0)
                                            }}</td>
                                        <td class="text-start">{{ item.status }}</td>
                                    </tr>
                                    <tr v-if="sortedMemos.length !== 0">
                                        <td colspan="7" class="text-center action">
                                            <router-link :to="{ name: 'ViewMemos', query: { status: 'pending' } }"
                                                class="view-link text-decoration-none mt-2">
                                                View More
                                            </router-link>
                                        </td>
                                    </tr>
                                    <tr v-if="sortedMemos.length === 0">
                                        <td colspan="7" class="text-center">No memos to display.</td>
                                    </tr>
                                </template>
                            </tbody>
                        </table>
                    </div>

                    <div v-else class="table-container border rounded rounded-table">
                        <table class="responsive-table">
                            <thead>
                                <tr>
                                    <th scope="col"></th>
                                    <th scope="col">Originating MDA</th>
                                    <th scope="col">Approval Authority</th>
                                    <th scope="col" class="text-end">Amount Approved</th>
                                    <th scope="col" class="text-end">Balance</th>
                                    <th scope="col">Appraisal Initiation Date</th>
                                    <th scope="col">Status</th>
                                    <!-- <th scope="col">Action</th> -->
                                </tr>
                            </thead>
                            <tbody>
                                <template v-if="loadingAppraisals">
                                    <tr v-for="n in 5" :key="'skeleton-' + n" class="skeleton-row">
                                        <td>
                                            <div class="skeleton-bar skeleton-sm mx-auto"></div>
                                        </td>
                                        <td>
                                            <div class="skeleton-bar"></div>
                                        </td>
                                        <td>
                                            <div class="skeleton-bar"></div>
                                        </td>
                                        <td>
                                            <div class="skeleton-bar"></div>
                                        </td>
                                        <td>
                                            <div class="skeleton-bar"></div>
                                        </td>
                                        <td>
                                            <div class="skeleton-bar"></div>
                                        </td>
                                        <td>
                                            <div class="skeleton-bar skeleton-sm"></div>
                                        </td>
                                    </tr>
                                </template>

                                <template v-else>
                                    <tr v-for="(appraisal, index) in sortedAppraisals.slice(0, 5)" :key="index"
                                        :class="index % 2 === 0 ? 'row-even' : 'row-odd'">
                                        <td scope="row" class="serial-no text-center">{{ index + 1 }}</td>
                                        <td class="primary-col text-start">
                                            <router-link v-if="appraisal.importedAppraisalInd == 1"
                                                :to="{ name: 'ViewManualAppraisal', params: { id: appraisal.id }, query: { mdaid: appraisal.mdaId, year: appraisal.year } }"
                                                class="view-link text-decoration-underline">
                                                {{ appraisal.originatingMda }}
                                            </router-link>

                                            <router-link v-else
                                                :to="{ name: 'ViewAppraisal', params: { id: appraisal.id }, query: { mdaid: appraisal.mdaId, year: appraisal.year } }"
                                                class="view-link text-decoration-underline">
                                                {{ appraisal.originatingMda }}
                                            </router-link>
                                        </td>
                                        <td class="secondary-col text-start">{{ appraisal.approvalAuthority }}</td>
                                        <td class="secondary-col text-end">{{ formatCurrency(appraisal.amountApproved ||
                                            0) }}
                                        </td>
                                        <td class="secondary-col text-end">{{ formatCurrency(appraisal.balance || 0) }}
                                        </td>
                                        <td class="secondary-col appraisal-date">
                                            <span v-if="appraisal.importedAppraisalInd === 1">
                                                N/A
                                            </span>
                                            <span v-else>{{ formatDate(appraisal.appraisalInitiatedDate) }}</span>
                                        </td>
                                        <td class="text-start">
                                            <span
                                                v-if="appraisal.warrantApprovedInd === 1 || appraisal.importedAppraisalInd === 1">Completed</span>
                                            <span v-else-if="appraisal.appraisalRejectedInd === 1">Rejected</span>
                                            <span v-else-if="appraisal.returned">Returned</span>
                                            <span v-else>Pending</span>
                                        </td>
                                        <!-- <td class="text-center action">
                                        <router-link v-if="appraisal.importedAppraisalInd == 1"
                                            :to="{ name: 'ViewManualAppraisal', params: { id: appraisal.id }, query: { mdaid: appraisal.mdaId, year: appraisal.year } }"
                                            class="view-link text-decoration-none">
                                            View
                                        </router-link>

                                        <router-link v-else
                                            :to="{ name: 'ViewAppraisal', params: { id: appraisal.id }, query: { mdaid: appraisal.mdaId, year: appraisal.year } }"
                                            class="view-link text-decoration-none">
                                            View
                                        </router-link>
                                    </td> -->
                                </tr>
                                <tr v-if="sortedAppraisals.length !== 0">
                                    <td colspan="7" class="text-center action">
                                        <router-link :to="{ name: 'ViewAppraisals', query: appraisalsQuery }"
                                            class="view-link text-decoration-none mt-2">
                                            View More
                                        </router-link>
                                    </td>
                                </tr>
                                <tr v-if="sortedAppraisals.length === 0">
                                    <td colspan="7" class="text-center">No appraisal requests to display.</td>
                                </tr>
                            </template>
                        </tbody>
                    </table>
                    </div>
                </div>
            </section>
        </div>
    </DashboardLayout>
</template>

<script setup>
import { ref, onMounted, defineOptions, watch, computed } from 'vue'
import axios from 'axios'
import Cookies from 'js-cookie';
import DashboardLayout from './layout/DashboardLayout.vue'
import '@/assets/css/table.css'
import Swal from 'sweetalert2';
import { useUserStore } from '@/stores/user'


const appraisals = ref([])
const warrants = ref([])
const memos = ref([])
const loadingAppraisals = ref(true)
const loadingMemos = ref(true)
const loadingCounts = ref(true)
const root_api_url = process.env.VUE_APP_API_ROOT_URL

const userStore = useUserStore()

// groupMember gets a "Recent Memos" widget instead of "Recent Appraisal
// Requests" — see fetchMemos/sortedMemos below.
const isGroupMember = computed(() => !!userStore.profile?.role?.groupMember)
const isGroupHead = computed(() => !!userStore.profile?.role?.groupHead)

// Official indicators: group members: 0; group head: 1; dob: 2; perm sec: 3;
// cbp: 4. Attached to the pending-appraisals query so ViewAppraisalsPage can
// auto-scope the list to the logged-in user's office.
const OFF_IND_BY_ROLE = {
    groupHead: 1,
    dirOfBudget: 2,
    perSec: 3,
    commOfBAndP: 4,
}

// Users outside the four official offices default to 5.
const offInd = computed(() => {
    const role = userStore.profile?.role || {}
    const matchedRole = Object.keys(OFF_IND_BY_ROLE).find(r => role[r])
    return matchedRole ? OFF_IND_BY_ROLE[matchedRole] : 5
})

// Attached to every ViewAppraisals navigation from this page, pending or not.
const appraisalsQuery = computed(() => ({ offInd: offInd.value }))

const pendingAppraisalQuery = computed(() => ({ status: 'pending', offInd: offInd.value }))

// TEMP: disables the mandatory change-password onboarding modal. Flip back
// to true before shipping.
// const ENABLE_PASSWORD_ONBOARDING = true

defineOptions({
    name: 'DashboardHomePage',
})

const allRoles = [
    'qssu',
    'dirOfBudget',
    'perSec',
    'commOfBAndP',
    'registryOfficer',
    'groupHead',
    'groupMember',
];

const hasAccess = (required) => {
    const profileRoles = userStore.profile?.role || {};

    const userHasRole = (role) => !!profileRoles[role];

    if (!required || required.length === 0) return true;

    if (required.includes('')) {
        const otherRoles = required.filter(role => role !== '');

        if (otherRoles.some(role => userHasRole(role))) return true;

        const isFreeUser = Object.keys(profileRoles).every(r => !allRoles.includes(r) || profileRoles[r] === false);
        if (isFreeUser) return true;

        return false;
    }

    return required.some(role => userHasRole(role));
}

const onBoarding = async () => {
    const iconHtmlSuccess = `<span class="iconify" data-icon="ci:circle-check" style="font-size: 100px; color: green;"></span>`

    const { value: formValues } = await Swal.fire({
        title: 'Welcome to OGPABS!',
        html: `
        <p>Before you continue, please change your password:</p>
        <br />
        <div class="form-outer">
            <div class="form-group">
                <label for="oldPassword">Old Password</label><br />
                <input type="password" id="oldPassword" class="input" placeholder="********" autocomplete="off" required>
                <span class="toggle-password" data-target="oldPassword">
                    <i class="far fa-eye"></i>
                </span>
            </div>

            <div class="form-group">
                <label for="newPassword">New Password</label><br />
                <input type="password" id="newPassword" class="input" placeholder="********" autocomplete="new-password" title="Password must contain at least 8 characters, 1 uppercase letter, 1 lowercase letter, 1 number, and 1 special character" required>

                <span class="toggle-password" data-target="newPassword">
                    <i class="far fa-eye"></i>
                </span>
            </div>

            <div class="form-group">
                <label for="confirmPassword">Confirm Password</label><br />
                <input type="password" id="confirmPassword" class="input" placeholder="********" autocomplete="new-password" title="Re-enter your new password" required>
                <span class="toggle-password" data-target="confirmPassword">
                    <i class="far fa-eye"></i>
                </span>
            </div>
        </div>
        `,
        icon: 'warning',
        confirmButtonText: 'Submit',
        showCancelButton: false,
        allowOutsideClick: false,
        allowEscapeKey: false,
        allowEnterKey: true,
        customClass: {
            popup: 'ogpabs-swal',
            htmlContainer: 'ogpabs-swal-html'
        },
        didOpen: (el) => {
            el.querySelectorAll('.toggle-password').forEach(btn => {
                btn.addEventListener('click', () => {
                    const targetId = btn.getAttribute('data-target');
                    const input = el.querySelector(`#${targetId}`);
                    const icon = btn.querySelector('i');

                    const isHidden = input.type === 'password';
                    input.type = isHidden ? 'text' : 'password';

                    icon.classList.toggle('fa-eye');
                    icon.classList.toggle('fa-eye-slash');
                });
            });
        },
        preConfirm: async () => {
            const password = document.getElementById('oldPassword').value
            const newPassword = document.getElementById('newPassword').value
            const confirmPassword = document.getElementById('confirmPassword').value

            const firstName = userStore.profile.firstName
            const lastName = userStore.profile.lastName
            const email = userStore.profile.userName

            if (!firstName || !lastName || !email) {
                Swal.showValidationMessage('User profile not loaded yet, please try again')
                return false
            }

            if (newPassword !== confirmPassword) {
                Swal.showValidationMessage('Passwords do not match')
                return false
            }

            try {
                const token = Cookies.get('auth_token')
                const response = await axios.post(`${root_api_url}/auth/reset-password`, {
                    firstName,
                    lastName,
                    email,
                    password,
                    newPassword,
                    confirmPassword
                }, {
                    headers: {
                        Authorization: `Bearer ${token}`,
                        'Content-Type': 'application/json',
                    },
                })
                if (response.status === 200) {
                    return true
                }
            } catch (error) {
                if (error?.response?.status === 417) {
                    Swal.showValidationMessage(error?.response?.data?.errorMessage || error?.response?.data?.error)
                } else if (error?.response?.status === 503) {
                    Swal.showValidationMessage(error.response?.data?.error)
                } else {
                    Swal.showValidationMessage('Failed to change password')
                }
                return false
            }
        }
    })

    if (formValues) {
        await Swal.fire({
            html: `${iconHtmlSuccess}<p>Password changed successfully!</p>`,
            showConfirmButton: true
        })
    }
}

const formatDate = (dateString) => {
    const date = new Date(dateString)
    return date.toLocaleDateString('en-US', {
        timeZone: 'UTC',
        year: 'numeric',
        month: 'short',
        day: 'numeric',
        hour: 'numeric',
        minute: '2-digit',
    })
}

function formatCurrency(val) {
    if (val === '' || val === null) return '';
    const num = parseFloat(val).toFixed(2);
    return '₦' + Number(num).toLocaleString(undefined, { minimumFractionDigits: 2, maximumFractionDigits: 2 });
}

const numberOfPendingAppraisals = ref(0)
const numberOfPendingMemos = ref(0)
const numberOfWarrantsThisMonth = ref(0)

const fetchWarrantsCount = async () => {
    const token = Cookies.get('auth_token');
    try {
        const response = await axios.get(`${root_api_url}/appraisal/warrant/all`, {
            headers: {
                Authorization: `Bearer ${token}`,
                'Content-Type': 'application/json',
            },
        });
        warrants.value = response.data;

        const now = new Date();
        numberOfWarrantsThisMonth.value = warrants.value.filter(warrant => {
            const issueDate = new Date(warrant.issueDate);
            return issueDate.getMonth() === now.getMonth() &&
                issueDate.getFullYear() === now.getFullYear()
        }).length;
    } catch (error) {
        console.error('Failed to fetch warrant count:', error);
        numberOfWarrantsThisMonth.value = 0;
    }
}

const fetchAppraisalsAndWarrantsCount = async () => {
    loadingCounts.value = true
    try {
        await fetchWarrantsCount()
    } finally {
        loadingCounts.value = false
    }
}

// Single call serves both the "Pending Appraisal Requests" count (via
// totalElements) and the Recent Appraisal Requests table (via content),
// instead of a separate count request plus a separate full-list fetch.
// statusInd=4 (pending) already excludes imported/completed/returned/
// rejected appraisals server-side (see AppraisalController), so no
// client-side status filtering is needed. The endpoint responds 200 OK with
// a plain string body (not a Page) when there's no data for the group,
// instead of an empty page — treat that as zero results.
const fetchPendingAppraisals = async () => {
    loadingAppraisals.value = true
    const token = Cookies.get('auth_token')
    try {
        const isGroupScopedUser = !!(userStore.profile?.role?.groupHead || userStore.profile?.role?.groupMember)
        const groupTypeId = userStore.profile?.groupTypeId

        if (isGroupScopedUser && !groupTypeId) {
            appraisals.value = []
            numberOfPendingAppraisals.value = 0
            return
        }

        const basePath = `${root_api_url}/appraisal/appraisal/all`
        const url = isGroupScopedUser ? `${basePath}/${groupTypeId}` : basePath

        const response = await axios.get(url, {
            headers: {
                Authorization: `Bearer ${token}`,
                'Content-Type': 'application/json',
            },
            params: { page: 0, size: 5, statusInd: 4, offInd: offInd.value },
        })

        const data = response.data
        if (!data || !Array.isArray(data.content)) {
            appraisals.value = []
            numberOfPendingAppraisals.value = 0
            return
        }

        appraisals.value = data.content.map(appraisal => ({
            id: appraisal.id,
            originatingMda: appraisal.originatingMda,
            approvalAuthority: appraisal.approvalAuthority,
            amountApproved: appraisal.amountApproved,
            balance: appraisal.balance,
            appraisalInitiatedDate: appraisal.appraisalInitiatedDate,
            mdaId: appraisal.mdaId,
            year: appraisal.year,
            warrantApprovedInd: appraisal.warrantApprovedInd,
            importedAppraisalInd: appraisal.importedAppraisalInd,
            appraisalRejectedInd: appraisal.appraisalRejectedInd,
            returned: appraisal.returned,
            sectoralHeadId: appraisal.sectoralHeadId,
        }))
        numberOfPendingAppraisals.value = data.page.totalElements ?? 0
    } catch (error) {
        console.error('Failed to fetch pending appraisals:', error)
        appraisals.value = []
        numberOfPendingAppraisals.value = 0
    } finally {
        loadingAppraisals.value = false
    }
}

// A returned appraisal only ever belongs to whichever group role is meant to
// fix it: sectoralHeadId null means the group head returned it themselves,
// so it's the group member's (handled separately in sortedMemos); set means
// a downstream stage returned it to the group head. DOB/perm sec/
// commissioner share this table but never own a returned appraisal, so they
// never see one here.
const isVisibleAsReturned = (appraisal) => {
    if (!appraisal.returned) return true
    return isGroupHead.value && !!appraisal.sectoralHeadId
}

// Most recently initiated first — the backend page isn't guaranteed sorted
// by date.
const sortedAppraisals = computed(() => {
    return [...appraisals.value].filter(isVisibleAsReturned).sort((a, b) => {
        const timeA = new Date(a.appraisalInitiatedDate).getTime() || 0
        const timeB = new Date(b.appraisalInitiatedDate).getTime() || 0
        return timeB - timeA
    })
})

// Most recently created first — the backend page isn't guaranteed sorted by
// date.
const sortedMemos = computed(() => {
    return [...memos.value].sort((a, b) => new Date(b.date) - new Date(a.date))
})

// statusInd=4 (pending) mirrors fetchPendingAppraisals' statusInd=4 above:
// the backend filters to pending memos server-side (MemoController), so a
// single paginated call serves both the "Pending Memos" count (via
// totalElements) and the Recent Memos table (via content), instead of the
// previous N+1 hasAppraisal-per-memo workaround.
const fetchMemos = async () => {
    loadingMemos.value = true
    const token = Cookies.get('auth_token')
    try {
        const isGroupScopedUser = !!(userStore.profile?.role?.groupHead || userStore.profile?.role?.groupMember)
        const groupTypeId = userStore.profile?.groupTypeId

        if (isGroupScopedUser && !groupTypeId) {
            memos.value = []
            numberOfPendingMemos.value = 0
            return
        }

        const basePath = `${root_api_url}/appraisal/memo/all`
        const url = isGroupScopedUser ? `${basePath}/${groupTypeId}` : basePath

        const response = await axios.get(url, {
            headers: {
                Authorization: `Bearer ${token}`,
                'Content-Type': 'application/json',
            },
            params: { page: 0, size: 5, statusInd: 4 },
        })

        const data = response.data
        if (!data || !Array.isArray(data.content)) {
            memos.value = []
            numberOfPendingMemos.value = 0
            return
        }

        memos.value = data.content.map(memo => ({
            type: 'memo',
            id: memo.id,
            fileTitle: memo.fileTitle,
            fileNumber: memo.fileNumber,
            date: memo.createdDate,
            originatingMda: memo.originatingMda,
            amountApproved: memo.amountApproved,
            mdaId: memo.mdaId,
            year: memo.year,
            status: 'Pending',
        }))
        numberOfPendingMemos.value = data.page.totalElements ?? 0
    } catch (error) {
        console.error('Failed to fetch memos:', error)
        memos.value = []
        numberOfPendingMemos.value = 0
    } finally {
        loadingMemos.value = false
    }
}

watch(
    () => userStore.profile?.deltaPasswordInd, (val) => {
        if (val == 1) {
            onBoarding()
        }
    }, { immediate: true }
)

const profileRoles = computed(() => userStore.profile?.role || {})
const menuVersion = ref(0)

watch(
    profileRoles,
    (newRoles, oldRoles) => {
        if (!oldRoles) {
            return
        }
        if (JSON.stringify(newRoles) !== JSON.stringify(oldRoles)) {
            menuVersion.value++
        }
    },
    { deep: true, immediate: true }
)

onMounted(async () => {
    if (userStore.profile?.deltaPasswordInd == 1) {
        await onBoarding();
    }
    // fetchPendingAppraisals (recent-requests table + count) and the
    // warrants count have no data dependency, so let them load in parallel.
    // Group members see Recent Memos instead, so fetch memos rather than
    // the appraisal list they won't see.
    const recentSectionFetch = isGroupMember.value ? fetchMemos() : fetchPendingAppraisals()
    await Promise.all([recentSectionFetch, fetchAppraisalsAndWarrantsCount()]);
    document.title = "Dashboard";
});
</script>

<style scoped>
.summary-table .responsive-table td {
    white-space: normal;
    word-break: break-word;
}

.summary-table .primary-col {
    max-width: 260px;
}

.summary-table td.secondary-col {
    max-width: 220px;
}

.summary-table .responsive-table td:last-child {
    white-space: nowrap;
}

.text-center.action .btn {
    background-color: #28A745 !important;
    border: none !important;
    border-radius: 0px !important;
}

.amount {
    padding-right: 3rem !important;
}

/* Summary cards - ensure proper stacking on mobile */
.summary {
    display: flex;
    gap: 1rem;
    margin-bottom: 2rem;
}

/* Mobile responsive - stack summary cards vertically */
@media (max-width: 768px) {
    .summary {
        flex-direction: column;
    }
}

.skeleton-bar {
    height: 14px;
    width: 100%;
    border-radius: 4px;
    background: linear-gradient(90deg, #eceff1 25%, #f5f6f7 37%, #eceff1 63%);
    background-size: 400% 100%;
    animation: skeleton-shimmer 1.4s ease infinite;
}

.skeleton-count {
    width: 140px;
}

.skeleton-bar.skeleton-sm {
    width: 24px;
}

.skeleton-row td {
    padding-top: 0.85rem;
    padding-bottom: 0.85rem;
}

@keyframes skeleton-shimmer {
    0% {
        background-position: 100% 50%;
    }

    100% {
        background-position: 0 50%;
    }
}

/* Quick Actions - responsive grid */
.action-container-row {
    gap: 1rem;
}

.single-action-wrapper {
    flex: 0 0 auto;
    width: calc(25% - 0.75rem);
    min-width: 150px;
}

/* Mobile - 2 columns */
@media (max-width: 768px) {
    .single-action-wrapper {
        width: calc(50% - 0.5rem);
    }
}

/* Small mobile - 1 column */
@media (max-width: 480px) {
    .single-action-wrapper {
        width: 100%;
    }
}

.single-action-card {
    background: var(--card );
    padding: 1rem;
    border-radius: 8px;
    text-align: center;
    transition: transform 0.2s;
    height: 100%;
    display: flex;
    flex-direction: column;
    align-items: center;
    justify-content: center;
}

.single-action-card:hover {
    transform: translateY(-2px);
    box-shadow: 0 4px 12px rgba(0, 0, 0, 0.1);
}

.action-icon {
    margin-bottom: 1rem;
}

.action-icon .material-symbols-outlined {
    font-size: 2.5rem;
}

.single-action-card h3 {
    font-size: 0.95rem;
    margin: 0;
}

:global(.ogpabs-swal .form-outer) {
    text-align: center;
    width: 410px;
    margin: 0 auto;
}

:global(.ogpabs-swal .form-group) {
    position: relative;
    text-align: left;
    margin: 10px auto;
    font-size: 16px;
}

:global(.ogpabs-swal .form-group label) {
    text-align: left !important;
    font-size: 16px;
    font-weight: 600;
    margin-bottom: 4px;
}

:global(.ogpabs-swal .form-group .input) {
    width: 100%;
    color: #000;
    border: 1px solid #C9C9C9;
    border-radius: 10px;
    padding: 6px 10px;
    box-sizing: border-box;
}

:global(.ogpabs-swal .form-group .input:focus-visible) {
    outline: none;
    border-color: #7aa7ff;
}

:global(.ogpabs-swal .toggle-password) {
    position: absolute;
    right: 10px;
    top: 32px;
    cursor: pointer;
    color: #888;
}

:global(.ogpabs-swal .toggle-password:hover) {
    color: #111;
}
</style>
